"use client";

import type { ReactNode } from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn, getAvatarFallbackClassName } from "@/lib/utils";

type Props = {
	avatarUrl?: string;
	fallback: ReactNode;
	border?: boolean;
	firstName?: string;
	lastName?: string;
};

function AvatarIcon(props: Props | null) {
	if (!props || typeof props !== "object") {
		return (
			<div className="flex size-10 items-center justify-center rounded-full border-2 border-tertiary bg-secondary-foreground text-base font-semibold dark:bg-core-midnight dark:text-foreground">
				?
			</div>
		);
	}

	const { avatarUrl, fallback, border = true, firstName, lastName } = props;

	return (
		<div
			className={cn(
				"relative size-full min-h-0 min-w-0 overflow-hidden rounded-full text-base font-semibold dark:text-foreground",
				{ "border-2 border-tertiary": border },
			)}
		>
			<Avatar className="size-full">
				<AvatarImage src={avatarUrl} alt="avatar" className="size-full border-accent" />
				<AvatarFallback
					className={cn("size-full font-semibold", getAvatarFallbackClassName(firstName, lastName))}
				>
					{fallback}
				</AvatarFallback>
			</Avatar>
		</div>
	);
}

export default AvatarIcon;
